module.exports = __webpack_public_path__ + "static/media/stockhausen_dortineinemanderen_8.2fb6ad05.jpeg";